  import React from 'react';
  import DonationTypes from '../components/Dons/DonationTypes';
  import DonationForm from '../components/Dons/DonationForm';

export default function Dons() {
  return (
    <>
      
      
        <DonationTypes />
        <DonationForm />
      
      
    </>
  );
}
